import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';

import { ToastService } from '../services/toast.service';
import { APP_ENVIRONMENT } from '../utils/environment.token';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const toastService = inject(ToastService);
  const router = inject(Router);
  const environment = inject(APP_ENVIRONMENT);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        console.error('HTTP error intercepted', {
          url: req.url,
          status: error.status,
          message: error.message
        });

        if (error.status === 429) {
          toastService.show(
            'Has enviado demasiadas solicitudes. Espera un momento antes de intentar nuevamente.',
            'info'
          );
        }

        const baseUrl = environment.apiUrl.replace(/\/$/, '');
        const isApiRequest = req.url.startsWith(baseUrl);
        const isServerDown = error.status === 0 || error.status >= 500;
        const isMaintenanceRoute = router.url.startsWith('/maintenance');
        if (environment.production && isApiRequest && isServerDown && !isMaintenanceRoute) {
          void router.navigateByUrl('/maintenance');
        }
      } else {
        console.error('Unexpected error intercepted', error);
      }

      return throwError(() => error);
    })
  );
};
